export const frontendDefaultPairInfoAbi = [
  {
    type: "function",
    name: "infoPairsStruct",
    inputs: [{ name: "pairs", type: "address[]", internalType: "address[]" }],
    outputs: [
      { name: "", type: "uint256", internalType: "uint256" },
      {
        name: "",
        type: "tuple[]",
        internalType: "struct Frontend_UserPairInfo.PairInfoStruct[]",
        components: [
          { name: "A", type: "address", internalType: "address" },
          { name: "N", type: "uint256[6]", internalType: "uint256[6]" },
        ],
      },
    ],
    stateMutability: "view",
  },
] as const
